import React, {useEffect, useState} from "react";
import {PlatformType} from "@commons/utils/fetchBaseFPNetQuery";
import {useAppDispatch} from "@hooks/redux-hooks/hooks";
import {attivaAccount} from "@commons/actions/user.action";
import Loading from "@components/dataTable/Loading";
import FPNetLogo from "@components/Logo";

export const ValidaEmail: React.FC<{ auxToken: string, device: PlatformType }> = ({auxToken, device}) => {
    const sfondo = {
        //"background": `url('${process.env.PUBLIC_URL}/images/File_001.jpeg')`,
        "background": `url('${process.env.PUBLIC_URL}/images/banner-img.jpg')`,
        "backgroundSize": "cover",
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
    }
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(true);
    const [success, setSuccess] = useState<boolean | null>(null);
    useEffect(() => {
        dispatch(attivaAccount(auxToken)).then((res) => {
            setLoading(false);
            if (res.type === attivaAccount.fulfilled.type) {
                setSuccess(true);
            } else if (res.type === attivaAccount.rejected.type) {
                setSuccess(false);
            }
        });
    }, [dispatch, auxToken]);

    const getURL = (platformType: PlatformType) => {
        let url;
        if (platformType === 'ios') {
            url = 'fpnet-app://home';
        } else if (platformType === 'android') {
            url = 'fpnet-app://home';
        } else {
            url = 'https://fpnet2.ericed.it/HR';
        }
        return url;
    }

    const refreshPage = () => {
        const url = getURL(device);
        window.open('fpnet-app://home', '_self');
    }

    return <>
        <div className="h-screen" style={sfondo}>
            <Loading loading={loading}>
                <div className="h-screen flex flex-col justify-center">
                    <div><FPNetLogo className="mx-auto h-20 w-auto"/></div>
                    {success === true &&
                        <div className="mt-2 sm:w-full sm:max-w-2xl bg-white py-8 px-4 shadow rounded-lg sm:px-10 sm:mx-auto">
                            <div className="flex flex-col justify-center text-green-500 bg-green-100 border border-green-500 rounded-md p-2 mb-3">
                                <div className="">
                                    <span className="font-bold">Il tuo account &egrave; stato validato!</span>
                                    <p>Ora puoi accedere ad FPNet&nbsp;
                                        {device === 'web' && 'tramite browser'}
                                        {device === 'ios' && 'con il tuo dispositivo iOS'}
                                        {device === 'android' && 'con il tuo dispositivo Android'}
                                        , ti basta premere il seguente pulsante:</p>
                                </div>
                                <div className="self-center m-3">
                                    <button onClick={() => refreshPage()}
                                            className="text-sm justify-center rounded-md border border-transparent bg-green-500 p-1 font-medium text-white shadow-sm
                                        hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                        Entra in FPNet!
                                    </button>
                                </div>
                                <div className="self-center m-3">
                                    {getURL(device)}
                                </div>
                            </div>
                        </div>
                    }
                    {success === false &&
                        <div className="mt-2 sm:w-full sm:max-w-2xl bg-white py-8 px-4 shadow rounded-lg sm:px-10 sm:mx-auto">
                            <div className="flex flex-col justify-center text-orange-500 bg-orange-100 border border-orange-500 rounded-md p-2 mb-3">
                                <div className="">
                                    <p><span className="font-bold">Attenzione:</span> Il tuo link di attivazione è scaduto!</p>
                                    Accedi ad FPNet per richiedere l'invio di una nuova email di attivazione, ti basta premere il seguente pulsante:
                                </div>
                                <div className="self-center m-3">
                                    <button onClick={() => refreshPage()}
                                            className="text-sm justify-center rounded-md border border-transparent bg-orange-500 p-1 font-medium text-white shadow-sm
                                        hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                        Entra in FPNet!
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Loading>
        </div>
    </>
}
export default ValidaEmail;